// Source:
// Countries with long/lat => https://developers.google.com/public-data/docs/canonical/countries_csv
// Countries images => https://github.com/djaiss/mapsicon

const countryCodesWithImage = [
  "1", "2", "3", "4"
];

export interface Country {
  code: string;
  latitude: number;
  longitude: number;
  name: string;
  district: string;
}

export const countries: Country[] = [
  { code: "1", latitude: 52.236944, longitude: 13.4375, name: 'Dabendorf', district: 'null' },
{ code: "2", latitude: 60.3925, longitude: 5.323333, name: 'Bergen', district: 'null' },
{ code: "3", latitude: 58.97, longitude: 5.731389, name: 'Stavanger', district: 'null' },
{ code: "4", latitude: 63.44, longitude: 10.4, name: 'Trondheim', district: 'null' },

];

export const countriesWithImage = countries.filter((c) =>
  countryCodesWithImage.includes(c.code.toLowerCase())
);

export function getCountryName(language: string, country: Country) {
  return country.name;
}

export function sanitizeCountryName(countryName: string): string {
  return countryName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[- '()]/g, "")
    .toLowerCase();
}
